module.exports = __webpack_public_path__ + "media/use_cases/slide2-7beeed22.png";